var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{staticClass:"vpn-section privacy-choice"},[_c('div',{staticClass:"vpn-section__inner"},[_c('h3',{staticClass:"vpn-section__title"},[_vm._v(_vm._s(_vm.choiceTitle))]),_vm._v(" "),_c('p',[_vm._v(_vm._s(_vm.choiceP1))]),_vm._v(" "),_c('p',[_vm._v(_vm._s(_vm.choiceP2))]),_vm._v(" "),_c('p',[_vm._v(_vm._s(_vm.choiceP3))])])])
}
var staticRenderFns = []

export { render, staticRenderFns }